var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackblaz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.83 173.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e21e29;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.72,155c-8.5,3.2-25.5,4.2-35-6.4-10.6-13.8-3.2-24.4-9.6-22.3-25.5,6.4-38.2-10.6-40.3-14.9,0,0-1.1-3.2-2.1,0h0c-1.1,4.2-1.1,12.7,1.1,21.2,2.1,10.6,10.6,27.6,31.8,37.2,18,7.4,41.4,4.2,56.3-11.7C94,152.9,94,152.9,87.72,155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.32,11.7A106.82,106.82,0,0,0,34.62,0c4.2,9.6,10.6,29.7-10.6,52h0C11.22,64.7,1.72,79.6,7,95.5c3.2,7.4,8.5,18,21.2,20.2,4.2,1.1,9.6,0,12.7-1.1,18-6.4,14.9-24.4,11.7-36.1a12.11,12.11,0,0,0-2.1-6.4c-3.2-12.7,5.3-20.2,7.4-28.7V37C59,23.4,51.62,18.1,46.32,11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.72,116.8c-1.1-11.7-6.4-20.2-20.2-36.1-6.4-7.4-11.7-17-11.7-24.4a30,30,0,0,1,5.3-13.8,52.4,52.4,0,0,0-8.5,6.4c-3.2,4.2-6.4,6.4-9.5,13.8v3.2c-2.1,11.7,7.4,22.3,4.2,37.2-1.1,3.2-2.1,5.3-5.3,11.7-3.2,8.5-3.2,19.1,2.1,25.5s13.8,8.5,22.3,6.4C99.32,143.4,106.82,130.6,105.72,116.8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackblaz);
export default __webpack_public_path__ + "static/media/blackblaz.12388a04955f9ad7e3ade7485ace7bdd.svg";
export { ForwardRef as ReactComponent };